import React from "react";
import BaseDrawer from "./BaseDrawer";
import CustomizerDrawerMenuPage from "../../mobile/CustomizerDrawerMenuPage";
import { Grid } from "@mui/material";

const FavoritesModal = ({
  isMobile,
  onClose,
  favoritePatches,
  handleFavoritePatch,
  handleCardClick,
}) => {
  if (!isMobile) {
    return null;
  }

  const unsetFavoritePatch = (p) => {
    handleFavoritePatch((prevState) => prevState.filter((patch) => patch.id !== p.id));
  };

  return (
    <BaseDrawer onClose={onClose} headline="Your Favorite Patches">
      <Grid container columns={3} spacing="9px" sx={{ width: "auto" }}>
        <CustomizerDrawerMenuPage
          isPatch
          isFavorites
          items={favoritePatches}
          handleCardClick={(i) => {
            handleCardClick(favoritePatches[i]);
            onClose();
          }}
          icon="src"
          favoritePatches={favoritePatches}
          handleFavoritePatch={unsetFavoritePatch}
        />
      </Grid>
    </BaseDrawer>
  );
};

export default FavoritesModal;
